export const FORM_SECURITY_LIMITS = {
  minSubmissionMs: 2000,
  maxPayloadBytes: 48000,
  maxNameChars: 80,
  maxEmailChars: 254,
  maxPhoneChars: 32,
  maxCompanyChars: 120,
  maxWebsiteChars: 200,
  maxLocationChars: 160,
  maxMessageChars: 2500,
  maxNotesChars: 1800,
} as const;

export function getUtf8ByteSize(value: string) {
  return new TextEncoder().encode(value).length;
}

export function isSubmissionTooFast(startedAt: number, minSubmissionMs: number) {
  return Date.now() - startedAt < minSubmissionMs;
}

export function exceedsPayloadLimit(value: string, maxPayloadBytes: number) {
  return getUtf8ByteSize(value) > maxPayloadBytes;
}
